import React from 'react'

import { usePortfolioNews } from './hooks/use-portfolio-news'
import { PortfolioNewsTemplate } from './template'

const PortfolioNews = (): React.JSX.Element => {
  const state = usePortfolioNews()

  return <PortfolioNewsTemplate isLoading={state.isLoading} state={state} />
}

export default PortfolioNews
